<template>
  <div>
    <section class="ftco-section login-wap position-relative BE-regular" :class="isMobile ? 'form-mobile' : ''" v-if="step === 1">
        <Header v-if="isMobile == 0" />
        <div class="wrapper-page">
            <div class="login-wrap">
                <h3 class="medium">{{ $t('text_1') }}</h3>
                <div class="login-form form-installment">
                    <p class="text-muted">{{ $t('text_2') }} <b class="text-danger">{{ $t('text_3') }}</b> {{ $t('text_4') }} <b class="text-success">{{ $t('text_5') }}</b> {{ $t('text_6') }}</p>
                    <div class="row g-2">
                        <div class="col-7">
                            <div class="form-floating mt-2">
                                <input @input="checkCardBin" type="tel" id="cardBin" class="form-control" :placeholder="labelCardBin" v-mask="'#### #### ####'" v-model="params.cardBin" :class="(errors.cardBin) ? 'errors' : ''">
                                <label :class="labelClassCardBin == true ? 'ping-pong' : ''" for="cardBin">{{ labelCardBin }}</label>
                                <a class="close-text" v-if="params.cardBin" @click="params.cardBin = ''">
                                  <img src="@/assets/images/close-text.svg">
                                </a>
                            </div>
                            <div v-if="errors.cardBin" class="text-danger BE-italic">{{ $t('text_29') }}</div>
                        </div>
                        <div class="col-5">
                            <div class="form-floating mt-2 expriedDate">
                                <input @input="checkExpriedDate" type="tel" id="expriedDate" class="form-control" placeholder="MM/YY" v-mask="'##/##'" v-model="params.expriedDate" :class="(errors.expriedDate) ? 'errors' : ''">
                                <label for="expriedDate">{{ $t('text_8') }}</label>
                                <a class="close-text" v-if="params.expriedDate" @click="params.expriedDate = ''">
                                  <img src="@/assets/images/close-text.svg">
                                </a>
                            </div>
                            <div v-if="errors.expriedDate" class="text-danger BE-italic">{{ $t('text_30') }}</div>
                            <div v-if="errors.expriedDateAgo" class="text-danger BE-italic">{{ $t('text_32') }}</div>
                        </div>
                    </div>

                    <div class="form-floating mb-3 mt-2">
                        <number type="tel" id="amount" class="form-control" :placeholder="$t('text_9')" v-model.number="params.amount" v-bind="{decimal: ',', separator: '.', prefix: '', precision: 0, masked: false, negative: false}" maxlength="12" :class="(errors.amount) ? 'errors' : ''"></number>
                        <label for="amount">{{ $t('text_9') }}</label>
                        <a class="close-text" v-if="params.amount" @click="params.amount = ''">
                          <img src="@/assets/images/close-text.svg">
                        </a>
                    </div>

                    <a @click="clickCheckCardBin" class="btn btn-danger w-100 mt-3">{{ $t('text_10') }}</a>

                    <p class="text-center my-4 text-choose"><span></span> {{ $t('text_48') }} </p>
                    <a class="link-bank pointer" @click="clickGetListBank">
                      <img src="@/assets/images/icon-bank.svg">{{ $t('text_38') }}
                    </a>
                </div>
            </div>
        </div>
        <div class="footer-installment"  v-if="isMobile == 0">
            <Support />
            <label class="toggle happy-sad">
                <input v-if="languageCode" type="checkbox" class="toggle-checkbox" v-model="languageCode" @click="clickLanguageCode" checked>
                <input v-else type="checkbox" class="toggle-checkbox" v-model="languageCode" @click="clickLanguageCode">
                <div class="toggle-btn"></div>
            </label>
        </div>
    </section>
    <section class="ftco-section login-wap position-relative BE-regular" :class="isMobile ? 'form-mobile' : ''" v-if="step === 2 && this.dataNext">
      <Header  v-if="isMobile == 0"/>
      <div class="wrapper-page">
          <div class="login-wrap login-wrap-ext">
              <div class="BE-bold lw-title lw-title-new">
                  <span class="fict-tick"><img src="@/assets/images/img-tick.svg"></span>
                  <article>
                      <label>{{ $t('text_11') }}</label>
                      <p class="text-muted">{{  $t('text_43') }} <b>{{  $t('text_44') }}</b> {{  $t('text_45') }} <b>{{  $t('text_46') }}</b> {{  $t('text_47') }}</p>
                  </article>
              </div>

              <div class="login-form form-installment form-mail-offs">
                  <div class="fi-card">
                      <div class="fic-top">
                          <span class="fict-logo" v-if="dataMpos.data && dataMpos.data.iconBank"><img :src="`${ dataMpos.data.iconBank }`"></span>
                          <label>
                            <div class="num-card" v-if="this.params.cardBin">{{ this.params.cardBin }}</div>
                            <span class="fs-14 BE-regular expr-card">{{ this.params.expriedDate }}</span>
                          </label>
                          <span class="fice-card" v-if="dataMpos.data && dataMpos.data.iconTypeCard"><img :src="`${ dataMpos.data.iconTypeCard }`"></span>
                      </div>
                  </div>
                  <div class="fi-price">
                    <p class="d-flex align-items-center justify-content-between">{{ $t('text_13') }}<label class="mb-0">{{formatNum(this.params.amount)}}đ <a href="javascript:void(0)" @click="modalUpdateAmount = true;updateAmount = params.amount"><img src="@/assets/images/edit-money.svg"></a></label></p>
                    <div class="choose-instalments choose-instalments-ext">
                      <p class="d-inline-block mb-0 me-3 fs-14" style="color: #808890;">{{ $t('text_14') }}</p>
                      <div class="ww-list ww-list-ext">
                        <ul v-if="arrPlans.length > 0">
                          <li v-for="(item, index) in arrPlans" :key="index">
                              <div class="middle">
                                  <label @click="clickFee(item)" :class="(item.checked === true) ? 'act' : ''">
                                      <div class="box">
                                          <span>
                                              <div class="ww-list-detail">
                                                  <h4>{{item.period}}</h4>
                                                  <p>{{ $t('text_15') }}</p>
                                              </div>
                                          </span>
                                      </div>
                                  </label>
                              </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <p>{{ $t('text_16') }}: <b>{{formatNum(oneAmount)}}đ</b></p>
                  </div>
                  <div class="fi-tabs" v-if="merchantId">
                      <p>{{ $t('text_17') }}</p>
                      <nav>
                          <div class="nav nav-tabs" id="nav-tab" role="tablist">
                              <button class="nav-link" :class="(activeTab==false) ? 'active' : ''" id="tab1" data-toggle="tab" data-target="#nav-home" type="button" @click="getDataMpos">{{ $t('text_18') }}</button>
                              <button class="nav-link" :class="(activeTab==true) ? 'active' : ''" id="tab2" data-toggle="tab" data-target="#nav-profile" type="button" @click="getDataMposLink">{{ $t('text_19') }}</button>
                          </div>
                      </nav>
                      <div class="tab-content" id="nav-tabContent">
                          <div class="tab-pane fade" :class="(activeTab==false) ? 'show active' : ''" id="nav-home" role="tabpanel" aria-labelledby="tab1">
                              <p class="mb-0 d-flex align-items-center justify-content-between"><span><input type="checkbox" v-model="checkFeeTrans" checked @change="clickCheckFeeTrans"> {{ $t('text_20') }}</span><span class="mb-0">{{formatNum(feeTrans)}}đ</span></p>
                              <p class="mb-0 d-flex align-items-center justify-content-between"><span><input type="checkbox" v-model="checkFeePlan" checked @change="clickCheckFeeTrans"> {{ $t('text_21') }}</span><span class="mb-0">{{formatNum(feePlan)}}đ</span></p>
                              <p class="mb-0 d-flex align-items-center justify-content-between">{{ $t('text_22') }}<label class="mb-0">{{formatNum(totalAmount)}}đ</label></p>
                          </div>
                          <div class="tab-pane fade" :class="(activeTab==true) ? 'show active' : ''" id="nav-profile" role="tabpanel" aria-labelledby="tab2">
                              <p class="mb-0 d-flex align-items-center justify-content-between"><span><input type="checkbox" v-model="checkFeeTrans" checked @change="clickCheckFeeTrans"> {{ $t('text_20') }}</span><span class="mb-0">{{formatNum(feeTrans)}}đ</span></p>
                              <p class="mb-0 d-flex align-items-center justify-content-between"><span><input type="checkbox" v-model="checkFeePlan" checked @change="clickCheckFeeTrans"> {{ $t('text_21') }}</span><span class="mb-0">{{formatNum(feePlan)}}đ</span></p>
                              <p class="mb-0 d-flex align-items-center justify-content-between">{{ $t('text_22') }}<label class="mb-0">{{formatNum(totalAmount)}}đ</label></p>
                          </div>
                      </div>
                  </div>
                  <a @click="clickReCheckCardBin" class="btn btn-outline-danger btn-mobile w-100 mt-3">{{ $t('text_23') }}</a>
                  <p class="text-muted mt-2 BE-italic text-center fs-14 text-mobile">
                    {{ $t('text_12') }}
                  </p>
              </div>
          </div>
      </div>
      <div class="footer-installment" v-if="isMobile == 0">
          <Support />
          <label class="toggle happy-sad">
              <input v-if="languageCode" type="checkbox" class="toggle-checkbox" v-model="languageCode" @click="clickLanguageCode" checked>
              <input v-else type="checkbox" class="toggle-checkbox" v-model="languageCode" @click="clickLanguageCode">
              <div class="toggle-btn"></div>
          </label>
      </div>
      <div v-if="modalUpdateAmount" >
        <div class="modal modal-bottom" :class="modalUpdateAmount ? 'fade show' : ''" style="display: block;">
          <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header justify-content-center text-center">
                    <h5 class="modal-title">{{ $t('text_35') }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="modalUpdateAmount = false"></button>
                </div>
                <div class="modal-body">
                    <div class="form-floating mt-2">
                      <number type="tel" id="amount" class="form-control BE-bold" :placeholder="$t('text_9')" v-model.number="updateAmount" v-bind="{decimal: ',', separator: '.', prefix: '', precision: 0, masked: false, negative: false}" maxlength="12" :class="(errors.amount) ? 'errors' : ''"></number>
                      <label for="amount">{{ $t('text_9') }}</label>
                      <a class="close-text" v-if="updateAmount" @click="updateAmount = ''">
                        <img src="@/assets/images/close-text.svg">
                      </a>
                    </div>
                    <div v-if="errorsUpdateAmount" class="text-danger BE-italic">{{ $t('text_33') }}</div>
                    <a href="javascript:void(0)" class="btn btn-danger w-100 mt-3" :class="updateAmount=='' ? 'btn-disabled' : ''" @click="clickUpdateAmount">
                        <span>{{ $t('text_36') }}</span>
                    </a>
                </div>
              </div>
          </div>
        </div>
        <div class="modal-backdrop" :class="modalUpdateAmount ? 'fade show' : ''"></div>
      </div>
    </section>

    <section class="ftco-section login-wap position-relative BE-regular" v-if="step === 3">
      <Header v-if="isMobile == 0" />
      <div class="wrapper-page">
        <div class="login-wrap">
          <h3 class="BE-bold justify-content-center title-search">
            <a @click="clickOutBank"><img src="@/assets/images/icon-close.svg"></a>
            {{ $t('text_37') }}
          </h3>
          <div class="login-form form-installment">
            <div class="form-floatings mb-3 mt-2">
              <input type="text" class="form-control form-search" :placeholder="`${ $t('text_41')}`" v-model="searchText">
              <span class="icon-search"><img src="@/assets/images/icon-bank-search.svg"></span>
            </div>
            <ul class="list-banks">
              <li v-for="(itemBank, indexBank) in searchTextBank" :key="indexBank">
                <a @click="clickGetByBank(itemBank.bankCode)"><img :src="`${ itemBank.logo }`"></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="footer-installment"  v-if="isMobile == 0">
            <Support />
            <label class="toggle happy-sad">
                <input v-if="languageCode" type="checkbox" class="toggle-checkbox" v-model="languageCode" @click="clickLanguageCode" checked>
                <input v-else type="checkbox" class="toggle-checkbox" v-model="languageCode" @click="clickLanguageCode">
                <div class="toggle-btn"></div>
            </label>
        </div>
    </section>
    <section class="ftco-section login-wap position-relative BE-regular" :class="isMobile ? 'form-mobile' : ''" v-if="step === 4">
      <Header v-if="isMobile == 0" />
      <div class="wrapper-page">
        <div class="login-wrap">
          <div class="login-form form-installment form-mail-offs">
            <div class="fi-select">
              <div class="fi-title d-flex align-items-center justify-content-between">
                  <p class="d-inline-block mb-0 me-3 fs-14" style="color: #808890;">{{ $t('text_42') }}</p>
                  <div class="fi-logo ">
                      <span><img :src="`${ bankSelect.logo }`"></span>
                      <a class="icon-change" @click="clickChoiseBank"><img src="@/assets/images/icon-change.svg"></a>
                  </div>
              </div>
              <div class="ww-list-visa clearfix">
                <ul class="ww-select-card-visa card-type" v-if="bankSelect">
                    <li v-for="(itemType, indexType) in bankSelect.cardType" :key="indexType">
                        <div class="middle-visa" @click="clickCardType(itemType)">
                            <label :class="(itemType.checked === true) ? 'act' : ''">
                                <div class="box-visa">
                                    <span><img :src="`${ itemType.logo }`"></span>
                                    <img src="@/assets/images/check-red.svg">
                                </div>
                            </label>
                        </div>
                    </li>
                  </ul>
              </div>
            </div>
            <div class="fi-price">
              <p class="d-flex align-items-center justify-content-between">{{ $t('text_13') }}<label class="mb-0">{{formatNum(this.params.amount)}}đ <a href="javascript:void(0)" @click="modalUpdateAmount = true;updateAmount = params.amount"><img src="@/assets/images/edit-money.svg"></a></label></p>
              <div class="choose-instalments choose-instalments-ext" v-if="arrPlansBank && arrPlansBank.length > 0">
                <p class="d-inline-block mb-0 me-3" style="color: #808890;">{{ $t('text_14') }}</p>
                <div class="ww-list">
                  <ul>
                    <li v-for="(item, index) in arrPlansBank" :key="index">
                        <div class="middle">
                            <label @click="clickFee(item)" :class="(item.checked === true) ? 'act' : ''">
                                <div class="box">
                                    <span>
                                        <div class="ww-list-detail">
                                            <h4>{{item.period}}</h4>
                                            <p>{{ $t('text_15') }}</p>
                                        </div>
                                    </span>
                                </div>
                            </label>
                        </div>
                    </li>
                  </ul>
                </div>
              </div>
              <p class="fi-price-one-ext" v-if="arrPlansBank && arrPlansBank.length > 0">{{ $t('text_16') }}: <b>{{formatNum(oneAmount)}}đ</b></p>
            </div>
            <div class="fi-tabs" v-if="merchantId">
                <p v-if="arrPlansBank && arrPlansBank.length > 0">{{ $t('text_17') }}</p>
                <nav v-if="arrPlansBank && arrPlansBank.length > 0">
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                        <button class="nav-link" :class="(activeTab==false) ? 'active' : ''" id="tab1" data-toggle="tab" data-target="#nav-home" type="button" @click="getDataMposBank">{{ $t('text_18') }}</button>
                        <button class="nav-link" :class="(activeTab==true) ? 'active' : ''" id="tab2" data-toggle="tab" data-target="#nav-profile" type="button" @click="getDataMposLinkBank">{{ $t('text_19') }}</button>
                    </div>
                </nav>
                <div class="tab-content" id="nav-tabContent" v-if="arrPlansBank && arrPlansBank.length > 0">
                    <div class="tab-pane fade" :class="(activeTab==false) ? 'show active' : ''" id="nav-home" role="tabpanel" aria-labelledby="tab1">
                        <p class="mb-0 d-flex align-items-center justify-content-between"><span class="fs-14"><input type="checkbox" v-model="checkFeeTrans" checked @change="clickCheckFeeTrans"> {{ $t('text_20') }}</span><span class="mb-0">{{formatNum(feeTrans)}}đ</span></p>
                        <p class="mb-0 d-flex align-items-center justify-content-between"><span class="fs-14"><input type="checkbox" v-model="checkFeePlan" checked @change="clickCheckFeeTrans"> {{ $t('text_21') }}</span><span class="mb-0">{{formatNum(feePlan)}}đ</span></p>
                        <p class="mb-0 d-flex align-items-center justify-content-between"><span class="fs-14">{{ $t('text_22') }}</span><label class="mb-0">{{formatNum(totalAmount)}}đ</label></p>
                    </div>
                    <div class="tab-pane fade" :class="(activeTab==true) ? 'show active' : ''" id="nav-profile" role="tabpanel" aria-labelledby="tab2">
                        <p class="mb-0 d-flex align-items-center justify-content-between"><span class="fs-14"><input type="checkbox" v-model="checkFeeTrans" checked @change="clickCheckFeeTrans"> {{ $t('text_20') }}</span><span class="mb-0">{{formatNum(feeTrans)}}đ</span></p>
                        <p class="mb-0 d-flex align-items-center justify-content-between"><span class="fs-14"><input type="checkbox" v-model="checkFeePlan" checked @change="clickCheckFeeTrans"> {{ $t('text_21') }}</span><span class="mb-0">{{formatNum(feePlan)}}đ</span></p>
                        <p class="mb-0 d-flex align-items-center justify-content-between"><span class="fs-14">{{ $t('text_22') }}</span><label class="mb-0">{{formatNum(totalAmount)}}đ</label></p>
                    </div>
                </div>
            </div>
            <a @click="clickReCheckCardBin" class="btn btn-outline-danger w-100 mt-3 btn-mobile">{{ $t('text_23') }}</a>
            <p class="text-muted mt-2 BE-italic fs-14">
              {{ $t('text_12') }}
            </p>
          </div>
        </div>
      </div>
      <div class="footer-installment" v-if="isMobile == 0">
          <Support />
          <label class="toggle happy-sad">
              <input v-if="languageCode" type="checkbox" class="toggle-checkbox" v-model="languageCode" @click="clickLanguageCode" checked>
              <input v-else type="checkbox" class="toggle-checkbox" v-model="languageCode" @click="clickLanguageCode">
              <div class="toggle-btn"></div>
          </label>
      </div>
      <div v-if="modalUpdateAmount" >
        <div class="modal modal-bottom" :class="modalUpdateAmount ? 'fade show' : ''" style="display: block;">
          <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header justify-content-center text-center">
                    <h5 class="modal-title">{{ $t('text_35') }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="modalUpdateAmount = false"></button>
                </div>
                <div class="modal-body">
                    <div class="form-floating mt-2">
                      <number type="tel" id="amount" class="form-control BE-bold" :placeholder="$t('text_9')" v-model.number="updateAmount" v-bind="{decimal: ',', separator: '.', prefix: '', precision: 0, masked: false, negative: false}" maxlength="12" :class="(errors.amount) ? 'errors' : ''"></number>
                      <label for="amount">{{ $t('text_9') }}</label>
                      <a class="close-text" v-if="updateAmount" @click="updateAmount = ''">
                        <img src="@/assets/images/close-text.svg">
                      </a>
                    </div>
                    <div v-if="errorsUpdateAmount" class="text-danger BE-italic">{{ $t('text_33') }}</div>
                    <a href="javascript:void(0)" class="btn btn-danger w-100 mt-3" :class="updateAmount=='' ? 'btn-disabled' : ''" @click="clickUpdateAmount">
                        <span>{{ $t('text_36') }}</span>
                    </a>
                </div>
              </div>
          </div>
        </div>
        <div class="modal-backdrop" :class="modalUpdateAmount ? 'fade show' : ''"></div>
      </div>
    </section>

    <section v-if="loading" class="ftco-section login-wap position-relative BE-regular ftco-section-loading">
      <div class="d-block text-center" style="margin-top:30vh">
          <div class="spinner-border text-danger" role="status">
              <span class="visually-hidden">{{ $t('text_31') }}</span>
          </div>
          <h3 class="d-block mt-3">{{ $t('text_31') }}</h3>
      </div>
    </section>

    <b-modal v-model="modalErrors" no-close-on-backdrop hide-header hide-footer dialog-class="np-modal">
      <div class="box-content text-center">
        <div class="text-message mt-0 mb-4">
          <div v-if="dataErrors.errorCode == '1001-01'">
              <img class="text-img-popup" src="@/assets/images/icon-popup/001.svg">
          </div>
          <div v-else>
              <img src="@/assets/images/icon-popup/002.svg">
          </div>
          <div class="text-head-popup">{{ dataErrors.errorTitle }}</div>
          <div class="text-desc-popup">{{ dataErrors.errorMessage }}</div>
        </div>
      </div>
      <div class="box-footer" v-if="dataErrors.errorCode == '1001-01'">
          <b-button variant="secondary" class="mr-1 w-48 btn-disabled" @click="modalErrors = false">{{ $t('text_25') }}</b-button>
          <b-button variant="primary" class="ml-1 w-48 btn-errors" @click="clickNext">{{ $t('text_26') }}</b-button>
      </div>
      <div class="box-footer" v-else-if="dataErrors.errorCode == '1006-01'">
        <b-button variant="primary" class="w-100 btn-errors" @click="modalErrors = false">{{ $t('text_34') }}</b-button>
      </div>
      <div class="box-footer" v-else>
        <b-button variant="primary" class="w-100 btn-errors" @click="modalErrors = false">{{ $t('text_24') }}</b-button>
      </div>
    </b-modal>
    <b-modal v-model="modalMposErrors" no-close-on-backdrop hide-header hide-footer dialog-class="np-modal">
      <div class="box-content text-center">
        <div class="text-message mt-0 mb-4">
            <div>
                <img class="text-img-popup" src="@/assets/images/icon-popup/002.svg">
            </div>
            <div class="text-head-popup">{{ dataMposErrors.errorTitle }}</div>
            <div class="text-desc-popup">{{ dataMposErrors.errorMessage }}</div>
        </div>
      </div>
      <div class="box-footer">
          <b-button variant="primary" class="w-100 btn-errors" @click="clickReCheckCardBin">{{ $t('text_24') }}</b-button>
      </div>
    </b-modal>
    <b-modal v-model="modalMposErrorsBank" no-close-on-backdrop hide-header hide-footer dialog-class="np-modal">
      <div class="box-content text-center">
        <div class="text-message mt-0 mb-4">
            <div>
                <img class="text-img-popup" src="@/assets/images/icon-popup/002.svg">
            </div>
            <div class="text-head-popup">{{ dataMposErrors.errorTitle }}</div>
            <div class="text-desc-popup">{{ dataMposErrors.errorMessage }}</div>
        </div>
      </div>
      <div class="box-footer">
          <b-button variant="primary" class="w-100 btn-errors" @click="clickReCheckBank">{{ $t('text_49') }}</b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { cloneData } from '@/utils/utils'
import { InstallMentService } from '@/services/installment.service.js'
import { AuthService } from '@/services/auth.service.js'
import Header from '@/components/header'
import Support from '@/components/support'
import { number } from '@coders-tm/vue-number-format'

export default {
  name: 'index',
  components: {
    Header,
    Support,
    number
  },
  data: () => {
    return {
      params: { cardBin: '', expriedDate: '', amount: '', languageCode: 'vie' },
      errors: { cardBin: false, expriedDate: false, expriedDateAgo: false, amount: false },
      merchantId: '',
      error: '',
      modalErrors: false,
      dataErrors: {},
      step: 1,
      dataNext: {},
      languageCode: false,
      arrPlans: [],
      oneAmount: 0,
      feePlan: 0,
      feeTrans: 0,
      totalAmount: 0,
      checkFeeTrans: true,
      checkFeePlan: true,
      planActive: {},
      modalMposErrors: false,
      dataMpos: {},
      dataMposErrors: {},
      isMobile: 0,
      activeTab: false,
      dataBinNotSupport: [],
      cardBin: 0,
      labelCardBin: '',
      labelClassCardBin: false,
      notMatch: false,
      maxlengthLable: 8,
      loading: false,
      modalUpdateAmount: false,
      updateAmount: '',
      errorsUpdateAmount: false,
      utmSource: '',
      // Luong bank
      dataBank: [],
      searchText: '',
      bankSelect: {
        bankCode: '',
        cardType: [],
        logo: ''
      },
      dataNextBank: {},
      arrPlansBank: [],
      modalMposErrorsBank: false
    }
  },
  async created () {
    this.loading = true
    await this.decodeURI()
    await this.getBinNotSupport()
    this.loading = false
  },
  methods: {
    clickLanguageCode () {
      this.languageCode = !this.languageCode
      this.params.languageCode = (this.languageCode === false) ? 'vie' : 'eng'
      this.$i18n.locale = this.params.languageCode
      AuthService.setLocalStorage('locale', this.params.languageCode)
      this.labelCardBin = this.$i18n.t('text_7_') + this.$i18n.t('text_7__') + this.$i18n.t('text_7')
    },
    async clickCheckCardBin () {
      // Check CardBin
      let cardBin = cloneData(this.params.cardBin)
      if (cardBin !== undefined) {
        cardBin = cardBin.replaceAll(' ', '').replaceAll('_', '')
        this.cardBin = cardBin
        if (cardBin.length < this.maxlengthLable || this.notMatch === true) {
          this.errors = { cardBin: true, expriedDate: false, amount: false }
          return false
        }
        if (cardBin.length < 8 || cardBin.length > 12) {
          this.errors = { cardBin: true, expriedDate: false, amount: false }
          return false
        } else {
          if (this.errors.cardBin) {
            this.errors = { cardBin: true, expriedDate: false, amount: false }
            return false
          } else {
            this.errors = { cardBin: false, expriedDate: false, amount: false }
          }
        }
      } else {
        this.errors = { cardBin: true, expriedDate: false, amount: false }
        return false
      }
      // Check expriedDate
      let expriedDate = cloneData(this.params.expriedDate)
      if (expriedDate === undefined) {
        this.errors = { cardBin: false, expriedDate: true, amount: false }
        return false
      } else {
        expriedDate = expriedDate.replace('_', '').replace('__', '')
        if (expriedDate.length < 5 || expriedDate.length > 5) {
          this.errors = { cardBin: false, expriedDate: true, amount: false }
          return false
        } else {
          const arrExpriedDate = expriedDate.split('/')
          if (arrExpriedDate[0] > 12 || arrExpriedDate[0] < 1) {
            this.errors = { cardBin: false, expriedDate: true, amount: false }
            return false
          } else {
            this.errors = { cardBin: false, expriedDate: false, amount: false }
          }
          if (arrExpriedDate.length === 1) {
            if (parseInt(arrExpriedDate[0]) >= 2 && parseInt(arrExpriedDate[0]) < 10) {
              this.params.expriedDate = '0' + parseInt(arrExpriedDate[0])
              return false
            }
          }
          if (arrExpriedDate.length === 2) {
            if (parseInt(arrExpriedDate[0]) >= 2 && parseInt(arrExpriedDate[0]) < 10) {
              arrExpriedDate[0] = '0' + parseInt(arrExpriedDate[0])
            }

            const yCurrent = new Date().getFullYear()
            const yLast = yCurrent.toString().slice(-2)
            let mCurrent = new Date().getMonth()

            if (arrExpriedDate[1] < yLast) {
              this.errors = { cardBin: false, expriedDateAgo: true, amount: false }
              return false
            } else {
              this.errors = { cardBin: false, expriedDateAgo: false, amount: false }
            }
            if (mCurrent < 12) { mCurrent = mCurrent + 1 }
            if (arrExpriedDate[1] === yLast && arrExpriedDate[0] < mCurrent) {
              this.errors = { cardBin: false, expriedDateAgo: true, amount: false }
              return false
            } else {
              this.errors = { cardBin: false, expriedDateAgo: false, amount: false }
            }
          }
        }
      }
      // Check amount
      const amount = cloneData(this.params.amount)
      if (amount === undefined || parseInt(amount) < 0 || isNaN(amount)) {
        this.errors = { cardBin: false, expriedDate: false, amount: true }
        return false
      } else {
        this.errors = { cardBin: false, expriedDate: false, amount: false }
      }

      const params = cloneData(this.params)
      params.cardBin = params.cardBin.replaceAll(' ', '').replaceAll('_', '')
      params.cardBin = params.cardBin.slice(0, 8)
      const arrExpriedDate = expriedDate.split('/')
      params.expriedDate = arrExpriedDate[1] + arrExpriedDate[0]
      params.amount = parseFloat(params.amount)
      params.languageCode = params.languageCode.substring(0, 2)
    
      const response = await InstallMentService.checkInfoCard(params)
      this.dataNext = response.data
      if (response.errorCode === '00') {
        await this.clickNext()
        return true
      } else {
        this.modalErrors = true
        this.dataErrors = response
      }
    },
    async clickNext () {
      if (this.merchantId !== '' && this.merchantId !== undefined) {
        await this.getDataMpos()
      } else {
        await this.initData()
      }
    },
    formatNum (val) {
      if (val <= 0) {
        return val
      }
      val = val.toString().split('.').join('')
      let output = ''
      while (val.length >= 3) {
        const last3Digits = val.slice(val.length - 3, val.length)
        val = val.slice(0, val.length - 3)
        output = '.' + last3Digits + output
      }
      if (val.length === 0) {
        output = output.slice(1, output.length)
      } else {
        output = val + output
      }
      return output
    },
    clickReCheckCardBin () {
      this.step = 1
      this.modalErrors = false
      this.modalMposErrors = false
    },
    async getDataMpos () {
      try {
        this.activeTab = false
        const paramsMpos = {
          merchantId: this.merchantId,
          cardType: this.dataNext.cardType,
          bankName: this.dataNext.bankCode,
          binCode: this.dataNext.bin.slice(0, 8)
        }
        this.dataMpos = await InstallMentService.getPlanByMerchant(paramsMpos)
        this.arrPlans = []
        if (this.dataMpos.errorCode === '00') {
          this.utmSource = (this.dataMpos.data.utmSource) ? this.dataMpos.data.utmSource : ''
          this.dataMpos.data.iconBank = require(`@/assets/images/icon-bank/${this.dataNext.bankCode}.svg`)
          this.dataMpos.data.iconTypeCard = require(`@/assets/images/icon-type/${this.dataNext.cardType}.svg`)
          if (this.dataMpos.data.listPeriodDTO.length > 0 && this.dataNext.plans.length > 0) {
            await this.dataMpos.data.listPeriodDTO.forEach(async (itemMp) => {
              await this.dataNext.plans.forEach(async (itemNig) => {
                if (itemMp.period === itemNig.numberOfInstallments) {
                  this.arrPlans.push(itemMp)
                }
              })
            })
            if (this.arrPlans.length > 0) {
              this.step = 2
              this.modalErrors = false
              this.clickFee(this.arrPlans[0])
            } else {
              this.errorStep()
            }
          }
        } else {
          this.errorStep(this.dataMpos.errorMessage)
        }
      } catch (err) {
        this.errorStep()
      }
    },
    async getDataMposLink () {
      try {
        this.activeTab = true
        const paramsMpos = {
          merchantId: this.merchantId,
          cardType: this.dataNext.cardType,
          bankName: this.dataNext.bankCode,
          binCode: this.dataNext.bin.slice(0, 8)
        }
        this.dataMpos = await InstallMentService.getPlanByMerchantLink(paramsMpos)
        this.arrPlans = []
        if (this.dataMpos.errorCode === '00') {
          this.utmSource = (this.dataMpos.data.utmSource) ? this.dataMpos.data.utmSource : ''
          this.dataMpos.data.iconBank = require(`@/assets/images/icon-bank/${this.dataNext.bankCode}.svg`)
          this.dataMpos.data.iconTypeCard = require(`@/assets/images/icon-type/${this.dataNext.cardType}.svg`)
          if (this.dataMpos.data.listPeriodDTO.length > 0 && this.dataNext.plans.length > 0) {
            await this.dataMpos.data.listPeriodDTO.forEach(async (itemMp) => {
              await this.dataNext.plans.forEach(async (itemNig) => {
                if (itemMp.period === itemNig.numberOfInstallments) {
                  this.arrPlans.push(itemMp)
                }
              })
            })
            if (this.arrPlans.length > 0) {
              this.step = 2
              this.modalErrors = false
              this.clickFee(this.arrPlans[0])
            } else {
              this.errorStep()
            }
          }
        } else {
          this.errorStep(this.dataMpos.errorMessage)
        }
      } catch (err) {
        this.errorStep()
      }
    },
    async clickFee (item) {
      this.planActive = item
      this.runCaculator(item)
    },
    clickCheckFeeTrans () {
      const item = this.planActive
      this.runCaculator(item)
    },
    runCaculator (item) {
      const transactionFee = cloneData(this.dataMpos.data.transactionFee)
      const installmentFee = (item.installmentFee) ? item.installmentFee : 0
    
      // True - True / False - False
      if ((this.checkFeeTrans === true && this.checkFeePlan === true) || (this.checkFeeTrans === false && this.checkFeePlan === false)) {
        this.totalAmount = Math.ceil((parseInt(this.params.amount) * 100) / (100 - parseFloat(transactionFee) - parseFloat(installmentFee)))
      }
      // True - False
      if (this.checkFeeTrans === true && this.checkFeePlan === false) {
        if (this.utmSource !== 'NGANLUONG') {
          this.totalAmount = Math.ceil((parseFloat(this.params.amount) * (100 - installmentFee)) / (100 - parseFloat(transactionFee) - parseFloat(installmentFee)))
        } else {
          this.totalAmount = Math.ceil((parseFloat(this.params.amount) * 100) / (100 - parseFloat(transactionFee)))
        }
      }
      // False - True
      if (this.checkFeeTrans === false && this.checkFeePlan === true) {
        if (this.utmSource !== 'NGANLUONG') {
          this.totalAmount = Math.ceil((parseInt(this.params.amount) * (100 - transactionFee)) / (100 - parseFloat(transactionFee) - parseFloat(installmentFee)))
        } else {
          this.totalAmount = Math.ceil((parseInt(this.params.amount) * 100) / (100 - parseFloat(installmentFee)))
        }
      }
    
      if (this.totalAmount % 1000 !== 0) {
        this.totalAmount = this.totalAmount + (1000 - parseInt(this.totalAmount % 1000))
      }

      if (this.checkFeeTrans === true && this.checkFeePlan === true) {
        this.feeTrans = Math.ceil(parseInt(this.totalAmount) * parseFloat(transactionFee) / 100)
        this.feePlan = Math.ceil(parseInt(this.totalAmount) - parseInt(this.params.amount) - parseFloat(this.feeTrans))
      }
      
      if (this.checkFeeTrans === true && this.checkFeePlan === false) { this.feePlan = 0; this.feeTrans = Math.ceil(parseInt(this.totalAmount) - parseInt(this.params.amount)) }
      if (this.checkFeeTrans === false && this.checkFeePlan === true) { this.feeTrans = 0; this.feePlan = Math.ceil(parseInt(this.totalAmount) - parseInt(this.params.amount)) }
      
      if (this.checkFeeTrans === false && this.checkFeePlan === false) { this.totalAmount = this.params.amount; this.feeTrans = 0; this.feePlan = 0 }
      
      if (this.merchantId) {
        this.oneAmount = Math.ceil(parseInt(this.totalAmount) / parseInt(item.period))
      } else {
        this.totalAmount = parseInt(this.params.amount)
        this.oneAmount = Math.ceil(parseInt(this.totalAmount) / parseInt(item.period))
      }
      this.oneAmount = Math.ceil(parseInt(this.totalAmount) / parseInt(item.period))
      
      item.checked = true
      this.arrPlans.filter((val) => val.period !== item.period).forEach((itemNote) => { itemNote.checked = false })
      this.arrPlansBank.filter((val) => val.period !== item.period).forEach((itemNote) => { itemNote.checked = false })
    },
    async initData () {
      this.arrPlans = []
      await this.dataNext.plans.forEach((itemNig) => {
        if (itemNig.numberOfInstallments > 0) {
          const itemMp = {}
          itemMp.period = itemNig.numberOfInstallments
          itemMp.installmentFee = 0
          itemMp.transactionFee = 0
          this.arrPlans.push(itemMp)
        }
      })
      const dataMpos = {
        data: {
          iconBank: require(`@/assets/images/icon-bank/${this.dataNext.bankCode}.svg`),
          iconTypeCard: require(`@/assets/images/icon-type/${this.dataNext.cardType}.svg`),
          transactionFee: 0
        }
      }
      this.dataMpos = dataMpos
      if (this.arrPlans.length > 0) {
        this.step = 2
        this.modalErrors = false
        this.clickFee(this.arrPlans[0])
      }
    },
    errorStep (errorMessage = '') {
      this.step = 1
      this.modalMposErrors = true
      this.dataMposErrors.errorTitle = this.$i18n.t('text_27')
      this.dataMposErrors.errorMessage = (errorMessage !== '') ? errorMessage : this.$i18n.t('text_28')
    },
    async decodeURI () {
      // const base64_encode = btoa('merchantId=1801&isMobile=0&amount=3000000&lang=vie')
      // https://domain.com?params=bWVyY2hhbnRJZD0xODAxJmlzTW9iaWxlPTA=
      let params = (this.$route.query.params) ? this.$route.query.params : ''
      if (params !== '') {
        params = atob(params)
        params = params.split('&')
        if (params.length > 0) {
          params.forEach((item) => {
            if (item !== '') {
              const itemVal = item.split('=')
              if (itemVal.length === 2) {
                if (itemVal[0] === 'merchantId') {
                  this.merchantId = itemVal[1]
                }
                if (itemVal[0] === 'isMobile') {
                  this.isMobile = parseInt(itemVal[1])
                }
                if (itemVal[0] === 'amount') {
                  this.params.amount = parseInt(itemVal[1])
                }
                if (itemVal[0] === 'lang') {
                  this.params.languageCode = itemVal[1]
                }
              }
            }
          })
        }
      }
      this.reloadLanguageCode()
    },
    reloadLanguageCode () {
      if (this.params.languageCode === 'vie') { this.languageCode = false } else { this.languageCode = true }
      this.$i18n.locale = this.params.languageCode
      AuthService.setLocalStorage('locale', this.params.languageCode)
      this.labelCardBin = this.$i18n.t('text_7_') + this.$i18n.t('text_7__') + this.$i18n.t('text_7')
    },
    async getBinNotSupport () {
      try {
        if (AuthService.isAccessTokenExpired()) {
          const response = await InstallMentService.getBinNotSupport()
          if (response.errorCode === '00') {
            this.dataBinNotSupport = (response.data.Bins) ? response.data.Bins : []
            AuthService.setLocalStorage('binNotSupport', this.dataBinNotSupport.join(','))
            AuthService.setAccessTokenExpDate()
          }
        } else {
          const dataBinNotSupport = AuthService.getLocalStorage('binNotSupport')
          if (dataBinNotSupport !== undefined && dataBinNotSupport !== null) {
            this.dataBinNotSupport = dataBinNotSupport.split(',')
          }
          AuthService.setAccessTokenExpDate()
        }
      } catch (err) {
        this.loading = false
      }
      // this.dataBinNotSupport = ['999999999999', '545968156101', '4444444', '333333', '55555555', '666666666', '7777777777', '88888888888']
      this.sapXepTheoDoDaiTangDan(this.dataBinNotSupport)
    },
    sapXepTheoDoDaiTangDan (arr) {
      arr.sort(function (a, b) { return a.length - b.length })
    },
    addSpaceEvery4Chars (inputString) {
      var result = ''
      for (var i = 0; i < inputString.length; i++) {
        result += inputString[i]
        if ((i + 1) % 4 === 0 && i !== inputString.length - 1) {
          result += ' '
        }
      }
      return result
    },
    removeError () {
      this.errors = { cardBin: false }
    },
    addError () {
      this.errors = { cardBin: true }
    },
    addLable (numbeer) {
      this.labelCardBin = this.$i18n.t('text_7_') + numbeer + this.$i18n.t('text_7')
    },
    removeLable () {
      this.labelCardBin = this.$i18n.t('text_7_') + 8 + this.$i18n.t('text_7')
    },
    updateInput (inputString) {
      if (this.errors.cardBin) {
        this.params.cardBin = this.addSpaceEvery4Chars(inputString.substring(0, inputString.length - 1))
      }
    },
    updateInputDefault (inputString) {
      this.params.cardBin = this.addSpaceEvery4Chars(inputString.substring(0, 8))
    },
    checkInput (inputString) {
      var errorInput = 'CHECKED'
      this.removeError()
      var maxLength1 = 8
      this.notMatch = false
      for (var i = 0; i < this.dataBinNotSupport.length; i++) {
        var item = this.dataBinNotSupport[i]
        if (item === inputString || (inputString.length >= item.length && item === inputString.substring(0, item.length))) {
          if (maxLength1 < item.length) {
            maxLength1 = item.length
            this.maxlengthLable = maxLength1
          }
          this.notMatch = true
        }

        if (inputString.length <= item.length && inputString.substring(0, inputString.length - 1) === item.substring(0, inputString.length - 1)) {
          if (maxLength1 < item.length) {
            maxLength1 = item.length
            this.maxlengthLable = maxLength1
          }
        }
      }
      if (inputString.length >= 8 && this.maxlengthLable >= 8) {
        this.addLable(this.maxlengthLable)
        this.labelClassCardBin = true
      }
      if (inputString.length < 8) {
        this.maxlengthLable = 8
        this.removeError()
        this.addLable(8)
      }
      if (this.notMatch === true && inputString.length === maxLength1) {
        errorInput = 'LOI'
      } else if (this.notMatch === true && inputString.length > maxLength1) {
        errorInput = 'LOI'
        this.params.cardBin = this.addSpaceEvery4Chars(inputString.substring(0, inputString.length - 1))
      } else if (inputString.length > this.maxlengthLable) {
        errorInput = 'CHECKED'
        this.params.cardBin = this.addSpaceEvery4Chars(inputString.substring(0, inputString.length - 1))
      } else {
        errorInput = 'TIEP'
      }
      return errorInput
    },
    checkCardBin () {
      let cardBin = cloneData(this.params.cardBin)
      if (cardBin !== undefined) {
        cardBin = cardBin.replaceAll(' ', '').replaceAll('_', '')
        var check = this.checkInput(cardBin)
        if (check === 'LOI' && cardBin.length >= 8) {
          this.addError()
        } else if (check === 'TIEP') {
          // console.log(check)
        } else if (check === 'CHECKED') {
          // console.log(check)
        }
      }
    },
    checkExpriedDate () {
      let expriedDate = cloneData(this.params.expriedDate)
      if (expriedDate !== undefined) {
        expriedDate = expriedDate.replace('_', '').replace('__', '')
        const arrExpriedDate = expriedDate.split('/')
        if (arrExpriedDate[0] > 12 || arrExpriedDate[0] < 1) {
          this.errors = { cardBin: false, expriedDate: true, amount: false }
          return false
        } else {
          this.errors = { cardBin: false, expriedDate: false, amount: false }
        }
        if (arrExpriedDate.length === 1) {
          if (parseInt(arrExpriedDate[0]) >= 2 && parseInt(arrExpriedDate[0]) < 10) {
            this.params.expriedDate = '0' + parseInt(arrExpriedDate[0])
            return false
          }
        }
        if (arrExpriedDate.length === 2) {
          if (parseInt(arrExpriedDate[0]) >= 2 && parseInt(arrExpriedDate[0]) < 10) {
            arrExpriedDate[0] = '0' + parseInt(arrExpriedDate[0])
          }

          const yCurrent = new Date().getFullYear()
          const yLast = yCurrent.toString().slice(-2)
          let mCurrent = new Date().getMonth()

          if (arrExpriedDate[1] < yLast) {
            this.errors = { cardBin: false, expriedDateAgo: true, amount: false }
            return false
          } else {
            this.errors = { cardBin: false, expriedDateAgo: false, amount: false }
          }
          if (mCurrent < 12) { mCurrent = mCurrent + 1 }
          if (arrExpriedDate[1] === yLast && arrExpriedDate[0] < mCurrent) {
            this.errors = { cardBin: false, expriedDateAgo: true, amount: false }
            return false
          }
          this.errors = { cardBin: false, expriedDateAgo: false, amount: false }
          this.params.expriedDate = arrExpriedDate[0] + '/' + arrExpriedDate[1]
          return false
        }
      } else {
        this.errors = { cardBin: false, expriedDate: false, amount: false }
      }
    },
    async clickUpdateAmount () {
      if (this.updateAmount === '') {
        return false
      }
      const updateAmount = parseFloat(this.updateAmount)
      if (updateAmount < 3000000) {
        this.errorsUpdateAmount = true
        return false
      } else {
        this.params.amount = updateAmount
        if (this.arrPlans.length > 0) {
          this.clickFee(this.arrPlans[0])
        }
        if (this.arrPlansBank.length > 0) {
          this.clickFee(this.arrPlansBank[0])
        }
        this.errorsUpdateAmount = false
        this.modalUpdateAmount = false
        return false
      }
    },

    // Luong bank
    clickOutBank () {
      this.step = 1
      this.searchText = ''
    },
    async clickGetListBank () {
      // Check amount
      const amount = cloneData(this.params.amount)
      if (amount === undefined || parseInt(amount) < 0 || isNaN(amount)) {
        this.errors = { cardBin: false, expriedDate: false, amount: true }
        return false
      } else {
        this.errors = { cardBin: false, expriedDate: false, amount: false }
      }

      this.step = 3
      const response = await InstallMentService.getBankSupport()
      if (response.errorCode === '00') {
        this.dataBank = response.data
        this.dataBank.map(item => {
          item.logo = require(`@/assets/images/logo-bank/${item.bankCode}.svg`)
        })
      }
    },
    async clickGetByBank (bankCode) {
      if (bankCode !== '') {
        const params = { bankCode: bankCode }
        const response = await InstallMentService.getInstallmentByBank(params)
        if (response.errorCode === '00') {
          const dataBank = response.data
          var tmpCardType = []
          if (dataBank.length > 0) {
            dataBank.forEach(item => {
              const cardType = item.cardType
              if (cardType.length > 0) {
                cardType.forEach(type => {
                  if (!tmpCardType.includes(type)) {
                    tmpCardType.push(type)
                  }
                })
              }
            })
          }
          const arrCardType = []
          if (tmpCardType.length > 0) {
            tmpCardType.forEach(type => {
              const tmp = { type: type, plans: [], dataPlans: [], bins: [], logo: '' }
              dataBank.forEach(item => {
                if (item.cardType.includes(type)) {
                  item.plans.forEach(plan => {
                    if (!tmp.plans.includes(plan.numberOfInstallments)) {
                      tmp.plans.push(plan.numberOfInstallments)
                      tmp.dataPlans.push(plan)
                    }
                  })
                  item.bin.forEach(_bin => {
                    if (!tmp.bins.includes(_bin)) {
                      tmp.bins.push(_bin)
                    }
                  })
                }
              })
              tmp.dataPlans = tmp.dataPlans.slice().sort((a, b) => a.numberOfInstallments - b.numberOfInstallments)
              tmp.plans = tmp.plans.slice().sort((a, b) => a - b)
              tmp.logo = require(`@/assets/images/icon-type-bank/${type}.svg`)
              arrCardType.push(tmp)
            })
          }
          this.step = 4
          this.bankSelect.bankCode = bankCode
          this.bankSelect.logo = require(`@/assets/images/logo-bank/${bankCode}.svg`)
          this.bankSelect.cardType = arrCardType
          if (this.bankSelect.cardType[0]) {
            this.bankSelect.cardType[0].checked = true
          }

          this.dataNextBank.bankCode = bankCode
          this.dataNextBank.cardType = (this.bankSelect.cardType[0].type) ? this.bankSelect.cardType[0].type : ''
          this.dataNextBank.plans = (this.bankSelect.cardType[0].dataPlans) ? this.bankSelect.cardType[0].dataPlans : []
          this.dataNextBank.bin = (this.bankSelect.cardType[0].bins[0]) ? this.bankSelect.cardType[0].bins[0] : ''
        
          if (this.merchantId !== '' && this.merchantId !== undefined) {
            await this.getDataMposBank()
          } else {
            await this.initDataBank()
          }
        }
      }
    },
    async getDataMposBank () {
      try {
        this.arrPlansBank = []
        this.activeTab = false
        const paramsMpos = {
          merchantId: this.merchantId,
          cardType: this.dataNextBank.cardType,
          bankName: this.dataNextBank.bankCode,
          binCode: this.dataNextBank.bin.slice(0, 8)
        }
        this.dataMpos = await InstallMentService.getPlanByMerchant(paramsMpos)
        if (this.dataMpos.errorCode === '00') {
          this.utmSource = (this.dataMpos.data.utmSource) ? this.dataMpos.data.utmSource : ''
          this.dataMpos.data.iconTypeCard = require(`@/assets/images/icon-type-bank/${this.dataNextBank.cardType}.svg`)
          if (this.dataMpos.data.listPeriodDTO.length > 0 && this.dataNextBank.plans.length > 0) {
            const arrPlansBank = []
            await this.dataMpos.data.listPeriodDTO.forEach(async (itemMp) => {
              await this.dataNextBank.plans.forEach(async (itemNig) => {
                if (itemMp.period === itemNig.numberOfInstallments) {
                  arrPlansBank.push(itemMp)
                }
              })
            })
            if (arrPlansBank.length > 0) {
              this.modalErrors = false
              this.arrPlansBank = arrPlansBank
              await this.clickFee(this.arrPlansBank[0])
            } else {
              this.errorStepBank()
            }
          } else {
            this.errorStepBank()
          }
        } else {
          this.errorStepBank(this.dataMpos.errorMessage)
        }
      } catch (err) {
        this.errorStep()
      }
    },
    async getDataMposLinkBank () {
      try {
        this.arrPlansBank = []
        this.activeTab = true
        const paramsMpos = {
          merchantId: this.merchantId,
          cardType: this.dataNextBank.cardType,
          bankName: this.dataNextBank.bankCode,
          binCode: this.dataNextBank.bin.slice(0, 8)
        }
        this.dataMpos = await InstallMentService.getPlanByMerchantLink(paramsMpos)
        if (this.dataMpos.errorCode === '00') {
          this.utmSource = (this.dataMpos.data.utmSource) ? this.dataMpos.data.utmSource : ''
          if (this.dataMpos.data.listPeriodDTO.length > 0 && this.dataNextBank.plans.length > 0) {
            await this.dataMpos.data.listPeriodDTO.forEach(async (itemMp) => {
              await this.dataNextBank.plans.forEach(async (itemNig) => {
                if (itemMp.period === itemNig.numberOfInstallments) {
                  this.arrPlansBank.push(itemMp)
                }
              })
            })
            if (this.arrPlansBank.length > 0) {
              this.modalErrors = false
              this.clickFee(this.arrPlansBank[0])
            } else {
              this.errorStepBank()
            }
          }
        } else {
          this.errorStepBank()
        }
      } catch (err) {
        this.errorStep()
      }
    },
    async initDataBank () {
      this.arrPlansBank = []
      await this.dataNextBank.plans.forEach((itemNig) => {
        if (itemNig.numberOfInstallments > 0) {
          const itemMp = {}
          itemMp.period = itemNig.numberOfInstallments
          itemMp.installmentFee = 0
          itemMp.transactionFee = 0
          this.arrPlansBank.push(itemMp)
        }
      })
      const dataMpos = {
        data: {
          iconTypeCard: require(`@/assets/images/icon-type-bank/${this.dataNextBank.cardType}.svg`),
          transactionFee: 0
        }
      }
      this.dataMpos = dataMpos
      if (this.arrPlansBank.length > 0) {
        this.modalErrors = false
        await this.clickFee(this.arrPlansBank[0])
      }
    },
    async clickCardType (itemType) {
      this.bankSelect.cardType.forEach((itemCheck) => { itemCheck.checked = false })
      itemType.checked = true
      this.dataNextBank.cardType = itemType.type
      this.dataNextBank.plans = itemType.dataPlans
      this.dataNextBank.bin = itemType.bins[0]
      if (this.merchantId !== '' && this.merchantId !== undefined) {
        await this.getDataMposBank()
      } else {
        await this.initDataBank()
      }
    },
    errorStepBank (errorMessage = '') {
      this.modalMposErrorsBank = true
      this.dataMposErrors.errorTitle = this.$i18n.t('text_27')
      this.dataMposErrors.errorMessage = (errorMessage !== '') ? errorMessage : this.$i18n.t('text_28')
    },
    clickChoiseBank () {
      this.step = 3
    },
    clickReCheckBank () {
      this.step = 3
      this.modalErrors = false
      this.modalMposErrors = false
      this.modalMposErrorsBank = false
    }
  },
  computed: {
    searchTextBank () {
      const query = this.searchText.toLowerCase()
      return this.dataBank.filter(item => item.bankCode.toLowerCase().includes(query))
    }
  }
}
</script>
